module.exports = __webpack_public_path__ + "static/media/pdi-image-11.499e2a46.svg";